import { toTrimmedString } from './shared';

const DEFAULT_SORT = { sortBy: 'updatedAt', sortOrder: 'DESC' };

const SORTABLE_COLUMN_MAP = {
  postedWeek: 'startDate',
  postedOn: 'updatedAt',
};

const BACKEND_SORTABLE_COLUMN_MAP = Object.entries(SORTABLE_COLUMN_MAP).reduce((acc, [frontendField, backendField]) => {
  acc[backendField] = frontendField;
  return acc;
}, {});

export const getBackendSortField = (columnAccessor) => SORTABLE_COLUMN_MAP[columnAccessor] || null;

export const getFrontendSortField = (sortField) => BACKEND_SORTABLE_COLUMN_MAP[sortField] || sortField;

export const parseSortString = (sortString) => {
  if (!sortString || typeof sortString !== 'string') {
    return { ...DEFAULT_SORT };
  }

  const [field, order] = sortString.split(':');
  const normalizedField = toTrimmedString(field);
  if (normalizedField === 'postingId') {
    return { ...DEFAULT_SORT };
  }

  const backendField = getBackendSortField(normalizedField) || normalizedField;

  return {
    sortBy: backendField,
    sortOrder: order?.toUpperCase() === 'ASC' ? 'ASC' : 'DESC',
  };
};

export const buildSortString = (columnAccessor, isDesc) => {
  const order = isDesc ? 'DESC' : 'ASC';
  return `${columnAccessor}:${order}`;
};
